import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import { SELF_TARGET } from '~/const/button';
export default {
  name: 'PricingPlan',
  components: {
    SimpleParagraph
  },
  props: {
    header: {
      type: Array,
      default: () => []
    },
    headerBgColor: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subtitleRich: {
      type: Array,
      default: () => []
    },
    price: {
      type: Array,
      default: () => []
    },
    subprice: {
      type: String,
      default: ''
    },
    subpriceStrike: {
      type: Boolean,
      default: false
    },
    image: {
      type: Object,
      default() {
        return {};
      }
    },
    cta: {
      type: String,
      default: ''
    },
    ctatheme: {
      type: String,
      default: ''
    },
    link: {
      type: Object,
      default() {
        return {};
      }
    },
    paragraphTitle: {
      type: Array,
      default: () => []
    },
    paragraph: {
      type: Array,
      default: () => []
    },
    tracking: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    ctaClasses() {
      if (this.ctatheme === 'link') return ['btn-link', 'btn-link-u'];
      var btnTheme = this.ctatheme === 'primary' ? 'dark' : 'light';
      return ['btn', "btn-".concat(btnTheme)];
    },
    target() {
      var _this$link$target;
      return (_this$link$target = this.link.target) !== null && _this$link$target !== void 0 ? _this$link$target : SELF_TARGET;
    }
  },
  methods: {
    onClick(event) {
      this.$root.$emit('generic-tracking', event, this.tracking);
    }
  }
};